document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector("#get-in-touch-form form")

  if (form) {
    const button = document.querySelector("#get-in-touch-button")

    const firstName = document.querySelector("input[name='contact_first_name']")
    const lastName = document.querySelector("input[name='contact_last_name']")
    const email = document.querySelector("input[name='contact_email']")
    const phoneNumber = document.querySelector("input[name='contact_phone_number']")
    const message = document.querySelector("textarea[name='contact_message']")
    const formElements = [firstName, lastName, email, phoneNumber, message];

    phoneNumber.addEventListener('input', formatPhone);

    formElements.forEach(element => element.addEventListener("input",
      ()=>errorCheck(formElements, button)
    ))

    const attachmentCancel = document.querySelectorAll(".attachment-cancel");
    [...attachmentCancel].forEach(element => element.addEventListener("click", e => removeAttachment(e)))

    const realFileInput = document.getElementById("attachment");
    const paperclip = document.getElementsByClassName("get-in-touch-attachment");
    [...paperclip].forEach(icon => icon.addEventListener("click", () => realFileInput.click()))
    realFileInput.addEventListener('change', (e) => displayAttachment(e))
  }
})

function removeAttachment(){
  const realFileInput = document.getElementById("attachment");
  const attachmentDisplay = document.querySelectorAll(".attachment-section__attached");
  realFileInput.value='';
  [...attachmentDisplay].forEach(element => element.classList.add('hidden'))
}

function displayAttachment(event){
  const attachmentDisplay = document.querySelectorAll(".attachment-section__attached");
  const filenameDisplay = document.querySelectorAll(".attachment-name-display");
  [...filenameDisplay].forEach(element => element.innerHTML=event.target.files[0].name);
  [...attachmentDisplay].forEach(element => element.classList.remove('hidden'));
}

function errorCheck(formElements, button){
  const missing = formElements.filter(element => !element.value);
  const emailElement = formElements[formElements.findIndex(el => el.getAttribute("name") === 'contact_email')]
  const emailRegex = new RegExp(/\S+@\S+\.\S+/);
  const emailWellFormed = !emailElement.value || emailRegex.test(emailElement.value)
  button.disabled = missing.length || !emailWellFormed;
}

function formatPhone(e) {
  var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
};

